type HeaderProps = {
  tastingTheme: string | null
  onEditClick: () => void
  onNewTasting: () => void
  showSave: boolean
  onSave: () => void
  isSaving: boolean
}

export function Header({ tastingTheme, onEditClick, onNewTasting, showSave, onSave, isSaving }: HeaderProps) {
  return (
    <header className="relative flex items-center justify-between px-4 pt-1.5 border-b border-black/10">
      <div className="flex items-center">
        <img src="/logo.svg" alt="" className="h-16 invisible" />
        <img src="/logo.svg" alt="LWWT" className="absolute h-16 -top-1" />
      </div>
      <div className="flex-1 text-center">
        {tastingTheme && (
          <span className={`text-black/70 ${tastingTheme.length > 22 ? 'text-sm' : 'text-lg'}`}>
            {tastingTheme}
          </span>
        )}
      </div>
      {tastingTheme && (
        <div className="flex items-center gap-2">
          {showSave && (
            <button
              onClick={onSave}
              disabled={isSaving}
              className="px-3 py-1.5 text-sm font-medium bg-black text-cream rounded hover:bg-black/80 transition-colors disabled:opacity-50"
            >
              {isSaving ? 'Saving...' : 'Save'}
            </button>
          )}
          <button
            onClick={onEditClick}
            className="px-3 py-1.5 text-sm font-medium bg-black text-cream rounded hover:bg-black/80 transition-colors"
          >
            Edit
          </button>
          <button
            onClick={onNewTasting}
            className="px-3 py-1.5 text-sm font-medium bg-black/10 text-black rounded hover:bg-black/20 transition-colors"
          >
            New
          </button>
        </div>
      )}
    </header>
  )
}
